import {DefaultInfoV1Props, DefaultNavLinkProps} from "@models/DefaultProps.ts";
import {IContaContabil} from "@models/contaContabil/contaContabil.ts";
import React from "react";
import {Grid, IconButton, TableCell, TableRow, Typography} from "@mui/material";
import {OpenInNew} from "@mui/icons-material";
import {createSearchParams, useNavigate} from "react-router";
import {NavigationLink} from "@shared/custom/NavigationLink.tsx";
import {useContextMenu} from "@contexts/hooks/useContextMenu.ts";

export interface ContaContabilInfoProps extends DefaultInfoV1Props<IContaContabil> {
    value: IContaContabil;
    variant: 'grid' | 'list' | 'navigationLink' | 'row';
    EndComponent?: (v: IContaContabil) => React.ReactNode;
}

export function ContaContabilInformacao(props: ContaContabilInfoProps) {
    if (props.variant == 'list') return <ContaContabilInfoList {...props}/>;
    if (props.variant == 'grid') return <ContaContabilInfoGrid {...props}/>;
    if (props.variant == 'navigationLink') return <ContaContabilInfoNavLink {...props}/>;
    if (props.variant == 'row') return <ContaContabilInfoRow {...props}/>;
}

export function ContaContabilInfoRow(props: Omit<ContaContabilInfoProps, 'variant' | 'removeOpenButton' | 'overrides'>) {
    const {value, EndComponent} = props;

    return (
        <TableRow>
            <TableCell>{value.id}</TableCell>
            <TableCell><ContaContabilInfoNavLink slotProps={{
                chip: {
                    tableMode: true,
                },
            }} value={value}/></TableCell>
            <TableCell>{value.nomeCompletoFormatado}</TableCell>
            <TableCell align={'right'}>{EndComponent &&
                <EndComponent {...value}/>}</TableCell>
        </TableRow>
    );
}

export function ContaContabilInfoNavLink(props: Omit<ContaContabilInfoProps, 'variant' | 'removeOpenButton' | 'overrides' | 'EndComponent'> & DefaultNavLinkProps<IContaContabil>) {
    const {setContextOptions} = useContextMenu()
    const {value} = props
    const navigate = useNavigate()
    const handleCtx = (e: React.MouseEvent<HTMLElement>) => {
        setContextOptions({
            event: e,
            anchor: e.currentTarget as HTMLElement, options: [
                {
                    label: "Ir para pagina de detalhes",
                    onClick: () => {
                        navigate({
                            pathname: '/contaContabil/detalhes',
                            search: createSearchParams({contaContabilId: props.value.id.toString()}).toString(),
                        })
                    }
                },
                {
                    label: value.isAtivo ? 'Desativar conta contábil' : 'Ativar conta contábil',
                    onClick: () => {
                        navigate({
                            pathname: '/contaContabil/detalhes',
                            search: createSearchParams({contaContabilId: props.value.id.toString()}).toString(),
                        })
                    }

                }
            ]
        })
    }

    return <NavigationLink pathName={'/contaContabil/Detalhes'}
                           searchData={{contaContabilId: props.value.id.toString()}}
                           onContextMenu={handleCtx}
                           label={props.value.nome}
                           chipSx={{...props.slotProps?.chip?.sx}}
                           tableMode={props.slotProps?.chip?.tableMode}
                           toolTipHint={"Ir para a pagina de detalhes da conta contabil " + props.value.nome}
    />;

}

export function ContaContabilInfoGrid(props: ContaContabilInfoProps,) {
    const {value} = props;

    return (<Grid size={12} px={1}>
        <Grid container justifyContent={"space-between"}
              sx={{height: '100%', maxHeight: '100%'}}>
            <Grid container alignContent={'center'} spacing={1}>
                <Grid>
                    <Typography>{value.id}</Typography>
                </Grid>
                <Grid>
                    <Typography>{value.nome}</Typography>
                </Grid>
            </Grid>
        </Grid>
    </Grid>);
}

export function ContaContabilInfoList(props: ContaContabilInfoProps) {
    const {value} = props;

    const navigate = useNavigate();
    return (<Grid size={12} px={1}>
        <Grid container justifyContent={"space-between"}
              sx={{height: '100%', maxHeight: '100%'}}>
            <Grid container alignContent={'center'} spacing={1}>
                <Grid>
                    <Typography>{value.nomeCompletoFormatado}</Typography>
                </Grid>
                <Grid>
                    <ContaContabilInfoNavLink {...props}/>

                </Grid>
            </Grid>
            <Grid container>
                {props.EndComponent && <Grid>
                        {props.EndComponent(value)}
                    </Grid> ||
                    props.EndComponent && <Grid>
                        <IconButton size={'small'} onClick={() => {
                            navigate({
                                pathname: '/contaContabil/detalhes',
                                search: createSearchParams({contaContabilId: value.id.toString()}).toString(),
                            });
                        }}
                        >
                            <OpenInNew/>
                        </IconButton>
                    </Grid>}
            </Grid>
        </Grid>

    </Grid>);
}